import { GroupRow } from "../../api/group.type";
import { RelationshipRow } from "../../api/relationship.type";
import ThemedSelect, { ThemedSelectOption } from "../shared/themed-select";

export default function ContactItemGroups({
  groups,
  contact,
  onAddToGroup,
  onRemoveFromGroup,
}: {
  groups: GroupRow[];
  contact: RelationshipRow;
  onAddToGroup: (groupId: string) => Promise<void> | void;
  onRemoveFromGroup: (groupId: string) => Promise<void> | void;
}) {
  return (
    <div className="w-40">
      {" "}
      {groups.length > 0 && (
        <ThemedSelect
          placeholder="Add to group"
          options={[
            ...(groups
              .filter(
                (g) =>
                  !g.user_group?.some(
                    (u) => u.user_id === contact.related_user_id
                  )
              )
              .map((g) => ({
                value: g.id,
                label: g.name,
              })) as ThemedSelectOption[]),
          ]}
          onChange={(e) => {
            e.stopPropagation();
            if (e.target.value) onAddToGroup(e.target.value);
          }}
          className="border rounded p-1 text-sm md:ml-4 mt-2 md:mt-0"
        />
      )}
      {groups.length > 0 && (
        <div className="mt-2 space-x-2">
          {groups
            .filter((g) =>
              g.user_group?.some((u) => u.user_id === contact.related_user_id)
            )
            .map((g) => (
              <span key={g.id} className="inline-flex items-center text-sm">
                {g.name}
                <button
                  className="ml-1 text-red-500"
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemoveFromGroup(g.id);
                  }}
                >
                  x
                </button>
              </span>
            ))}
        </div>
      )}
    </div>
  );
}
